var _path, _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEur(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_598_24642)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_598_24642",
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: 0,
    width: 36,
    height: 24,
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6 2.4C-6 1.07452 -4.92548 0 -3.6 0H27.6C28.9255 0 30 1.07452 30 2.4V21.6C30 22.9255 28.9255 24 27.6 24H-3.6C-4.92548 24 -6 22.9255 -6 21.6V2.4Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_598_24642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6 2.4C-6 1.07452 -4.92548 0 -3.6 0H27.6C28.9255 0 30 1.07452 30 2.4V21.6C30 22.9255 28.9255 24 27.6 24H-3.6C-4.92548 24 -6 22.9255 -6 21.6V2.4Z",
    fill: "#0A17A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6 0.6H-3.6C-4.59411 0.6 -5.4 1.40589 -5.4 2.4V21.6C-5.4 22.5941 -4.59411 23.4 -3.6 23.4H27.6C28.5941 23.4 29.4 22.5941 29.4 21.6V2.4C29.4 1.40589 28.5941 0.6 27.6 0.6ZM-3.6 0C-4.92548 0 -6 1.07452 -6 2.4V21.6C-6 22.9255 -4.92548 24 -3.6 24H27.6C28.9255 24 30 22.9255 30 21.6V2.4C30 1.07452 28.9255 0 27.6 0H-3.6Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2649 3.89349L11.9765 3L11.6881 3.89349H10.7549L11.5099 4.44569L11.2215 5.33918L11.9765 4.78697L12.7315 5.33918L12.4431 4.44569L13.1981 3.89349H12.2649ZM8.4114 4.89919L8.12301 4.0057L7.83463 4.89919L6.90141 4.89919L7.6564 5.45139L7.36802 6.34488L8.12301 5.79267L8.87801 6.34488L8.58963 5.45139L9.34462 4.89919L8.4114 4.89919ZM15.8775 4.0057L16.1659 4.89919L17.0991 4.89919L16.3441 5.45139L16.6325 6.34488L15.8775 5.79267L15.1225 6.34488L15.4109 5.45139L14.6559 4.89919L15.5891 4.89919L15.8775 4.0057ZM5.50941 7.77268L5.22103 6.8792L4.93265 7.77268H3.99942L4.75442 8.32489L4.46604 9.21838L5.22103 8.66617L5.97603 9.21838L5.68764 8.32489L6.44264 7.77268H5.50941ZM18.7318 6.8792L19.0202 7.77268H19.9534L19.1984 8.32489L19.4868 9.21838L18.7318 8.66617L17.9768 9.21838L18.2652 8.32489L17.5102 7.77268H18.4434L18.7318 6.8792ZM12.2649 19.554L11.9765 18.6605L11.6881 19.554H10.7549L11.5099 20.1062L11.2215 20.9997L11.9765 20.4475L12.7315 20.9997L12.4431 20.1062L13.1981 19.554H12.2649ZM8.12301 17.6068L8.4114 18.5003H9.34462L8.58963 19.0525L8.87801 19.946L8.12301 19.3938L7.36802 19.946L7.6564 19.0525L6.90141 18.5003H7.83463L8.12301 17.6068ZM16.1659 18.5003L15.8775 17.6068L15.5891 18.5003H14.6559L15.4109 19.0525L15.1225 19.946L15.8775 19.3938L16.6325 19.946L16.3441 19.0525L17.0991 18.5003H16.1659ZM5.22103 14.7333L5.50941 15.6268H6.44264L5.68764 16.179L5.97603 17.0725L5.22103 16.5203L4.46604 17.0725L4.75442 16.179L3.99942 15.6268H4.93265L5.22103 14.7333ZM19.0202 15.6268L18.7318 14.7333L18.4434 15.6268H17.5102L18.2652 16.179L17.9768 17.0725L18.7318 16.5203L19.4868 17.0725L19.1984 16.179L19.9534 15.6268H19.0202ZM4.22161 10.8064L4.50999 11.6999H5.44322L4.68822 12.2521L4.9766 13.1456L4.22161 12.5934L3.46661 13.1456L3.755 12.2521L3 11.6999H3.93323L4.22161 10.8064ZM20.0668 11.6999L19.7784 10.8064L19.49 11.6999H18.5568L19.3118 12.2521L19.0234 13.1456L19.7784 12.5934L20.5334 13.1456L20.245 12.2521L21 11.6999H20.0668Z",
    fill: "#FFE805"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_598_24642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/EUR.8e06d0b57b44bf0e019be69fa34df507.svg";
export { ForwardRef as ReactComponent };